export const MENU = [
	{
		link:'dashboard',
		isModal: false,
		label:'Mi Bandeja',
		className: ''
	},
	{
		link:'',
		isModal: true,
		label:'Reportes',
		className: ''
	}
]


// WEBPACK FOOTER //
// ./src/constants/app/menu.js